import { render } from "./InjuryPart.vue?vue&type=template&id=7bbd93bf&scoped=true"
import script from "./InjuryPart.vue?vue&type=script&lang=js"
export * from "./InjuryPart.vue?vue&type=script&lang=js"

import "./InjuryPart.vue?vue&type=style&index=0&id=7bbd93bf&lang=scss&scoped=true"
import "./InjuryPart.vue?vue&type=style&index=1&id=7bbd93bf&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbd93bf"]])

export default __exports__